import { useTheme } from "@mui/material";
import { Users } from "lucide-react";
import { type FC, useState } from "react";
import type { InsuredPersonDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { InsuredPersonDetailDrawer } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/InsuredPersonDetailDrawer";
import { getInsuredPersonName } from "web_myplann/Portfolio/Helpers/insuredPersonLabels";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	insuredPersons: InsuredPersonDTO[];
	currencySign: string;
};

export const InsuredPersonsList: FC<Props> = ({
	insuredPersons,
	currencySign,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const [selectedPerson, setSelectedPerson] = useState<InsuredPersonDTO>();
	const [isPersonOpen, setIsPersonOpen] = useState(false);

	const openPerson = (person: InsuredPersonDTO) => {
		setSelectedPerson(person);
		setIsPersonOpen(true);
	};

	if (insuredPersons.length === 0) {
		return null;
	}

	return (
		<>
			<DetailCard
				label={t(Resources.PortfolioDetail.LifeInsurance.EnsuredPeople.title)}
			>
				{insuredPersons.map((person, index) => (
					<ListRow
						key={person.id}
						title={getInsuredPersonName(person)}
						subtitle={t(
							Resources.Portfolio.AddLifeInsurance.InsuredPersons.riskCount,
							{ count: person.risks.length },
						)}
						icon={<Users size={18} color={theme.palette.blue[600]} />}
						iconBg={theme.palette.blue[50]}
						showChevron
						isLast={index === insuredPersons.length - 1}
						onClick={() => openPerson(person)}
					/>
				))}
			</DetailCard>

			<InsuredPersonDetailDrawer
				open={isPersonOpen}
				person={selectedPerson}
				currencySign={currencySign}
				onClose={() => setIsPersonOpen(false)}
			/>
		</>
	);
};
